module.exports = __webpack_public_path__ + "img/B高通50.e2203437.png";